module.exports = __webpack_public_path__ + "img/block2-3.e585bfd2.svg";